import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  input: {
    display: 'flex',
    gap: 10,
    justifyContent: 'center',
    marginBottom: 8
  },
  info: {
    textAlign: 'center',
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 12,
      lineHeight: '19.92px',
      letterSpacing: 0.4,
      marginTop: 30
    }
  },
  error: {
    marginTop: 12,
    alignItems: 'center'
  },
  time: {
    color: '#FF9800'
  },
  button: {
    width: 'fit-content',
    '&.MuiButton-root': {
      margin: '16px auto 0 auto'
    }
  }
}));
